export default __webpack_public_path__ + "static/Clarendon_Hotel_6-7a260bd6b919540d393f6d6d37975f55.jpg";